var exports = {
  "q": "x936d19a0--ec2269--footer",
  "H": "x936d19a0--ec2269--button-wrapper",
};

module.exports = exports;
